import type { MaacRoleName } from "@polifonia/interlude/models";
import { MaacRoleNameSchema } from "@polifonia/interlude/models";

export const isMaacRole = (role: string): role is MaacRoleName => {
  return MaacRoleNameSchema.safeParse(role).success;
};
